/** basic.deviceType */
export default {
    type_name: "Название типа",
    type_namePla: "Введите название типа",
    type_coding: "Код типа",
    type_codingPla: "Введите код типа",
    type_drawerTitle: "Детали типа устройства",
    type_dialogTitle: "Новый тип устройства",
    type_id: "ID типа",
}

